import { AppConfigService } from '../../../../app-config.service';
import { BffCommunicationService } from '../../../../core/services/bff-communication.service';
import { ErreurValidationModel } from '../../models/erreur-validation.modele';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PreautorisationModel } from '../../models/preautorisation.model';
import { ValiderCodeInvitationCourrielModel } from '../../models/valider-code-invitation-courriel.model';
import { ResultatPreadmissibiliteModel } from '../../models/resultat-preadmissibilite.model';
import { TypeProjet } from 'src/app/shared/constants/type-projet.enum';

@Injectable({
  providedIn: 'root'
})
export class PreautorisationApiService {
  constructor(
    private readonly _bffApiService: BffCommunicationService,
    private readonly _appConfigService: AppConfigService
  ) {}

  private get idProjet() {
    return this._appConfigService.idProjet;
  }

  private get apiUrlV1(): string {
    return `/api/v1/projets/${this.idProjet}/preautorisationsenligne`;
  }

  private get apiUrlV2(): string {
    return `/api/v2/projets/${this.idProjet}/preautorisationsenligne`;
  }

  getPreautorisation(): Promise<PreautorisationModel> {
    return this._bffApiService.getJSONBFF(this.apiUrlV1).toPromise() as Promise<PreautorisationModel>;
  }

  prefillPreautorisation(): Promise<PreautorisationModel> {
    return this._bffApiService.getJSONBFF(`${this.apiUrlV1}/initialiser`).toPromise() as Promise<PreautorisationModel>;
  }

  submitPreautorisation(
    preautorisation: PreautorisationModel,
    idTexteConsentement: string,
    numeroDemande?: string
  ): Promise<any> /* PreautorisationModel | ErreurValidationModel */ {
    const numeroDemandeParam = numeroDemande ? `&numeroDemande=${numeroDemande}` : '';
    return this._bffApiService
      .postJSONBFF(`${this.apiUrlV2}?idTexteConsentement=${idTexteConsentement}${numeroDemandeParam}`, preautorisation)
      .toPromise() as Promise<PreautorisationModel | ErreurValidationModel>;
  }

  deletePreautorisation(idPreautorisation: string, codeInvitation?: string): Promise<PreautorisationModel> {
    const codeInvitationParam = codeInvitation ? `?codeInvitation=${codeInvitation}` : '';
    return this._bffApiService
      .deleteBFF(`${this.apiUrlV1}/${idPreautorisation}${codeInvitationParam}`)
      .toPromise() as Promise<PreautorisationModel>;
  }

  updatePrimeSCHL(
    miseDeFond: number,
    montantPropriete: number,
    nombreUniteLogement: number,
    typePreautorisation: TypeProjet
  ): Promise<number> {
    const queryParams = new URLSearchParams({
      miseDeFond: miseDeFond.toString(),
      montantPropriete: montantPropriete.toString(),
      nombreUniteLogement: nombreUniteLogement.toString(),
      typePreautorisation
    });
    return this._bffApiService
      .getJSONBFF(`/api/v1/projets/${this.idProjet}/calculerprime?${queryParams.toString()}`)
      .toPromise() as Promise<number>;
  }

  accepterContreOffre(): Promise<PreautorisationModel> {
    return this._bffApiService.postJSONBFF(`${this.apiUrlV2}/contreoffre/accepter`, '').toPromise() as Promise<
      PreautorisationModel
    >;
  }

  refuserContreOffre(): Promise<PreautorisationModel> {
    return this._bffApiService.postJSONBFF(`${this.apiUrlV2}/contreoffre/refuser`, '').toPromise() as Promise<
      PreautorisationModel
    >;
  }

  selectionnerTaux(idOffreTarificationBancaire: string): Promise<PreautorisationModel> {
    return this._bffApiService
      .putJSONBFF(`${this.apiUrlV2}/selectiontaux`, {
        idOffreTarificationBancaire
      })
      .toPromise() as Promise<PreautorisationModel>;
  }

  validatePreadmissibilite(): Observable<ResultatPreadmissibiliteModel> {
    return this._bffApiService.postJSONBFF(`${this.apiUrlV2}/preadmissibilite`, '') as Observable<
      ResultatPreadmissibiliteModel
    >;
  }

  validateCodeInvitationCoemprunteur(
    validercodeinvitationCourriel: ValiderCodeInvitationCourrielModel
  ): Promise<PreautorisationModel> {
    return this._bffApiService
      .postJSONBFF(`/api/v1/projets/${this.idProjet}/validercodeinvitation`, validercodeinvitationCourriel)
      .toPromise() as Promise<PreautorisationModel>;
  }
}
